"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReloadPage = getReloadPage;
exports.getFromTo = getFromTo;
function getReloadPage(itemsList, currentPage) {
  var page = currentPage;
  if (!itemsList.length && currentPage > 1) {
    page -= 1;
  }

  return page;
}

function getFromTo(_ref) {
  var page = _ref.page,
      limit = _ref.limit;

  var from = (page - 1) * limit;
  var to = page * limit;
  return { from: from, to: to };
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/pagination.js
// module id = 357
// module chunks = 1